import React from "react";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";

// Sample data
const data = [
  { date: "Nov 01", regDown: 4000, regUp: 2400, spinning: 1000, energy: 8000, cumulative: 8000 },
  { date: "Nov 03", regDown: 3000, regUp: 2000, spinning: 1500, energy: 6000, cumulative: 14000 },
  { date: "Nov 05", regDown: 5000, regUp: 4000, spinning: 2000, energy: 10000, cumulative: 24000 },
  { date: "Nov 07", regDown: 2500, regUp: 3000, spinning: 1800, energy: 7000, cumulative: 31000 },
  { date: "Nov 09", regDown: 3200, regUp: 4500, spinning: 2200, energy: 9000, cumulative: 40000 },
  { date: "Nov 12", regDown: 4000, regUp: 5000, spinning: 2500, energy: 10000, cumulative: 50000 },
  { date: "Nov 15", regDown: 300, regUp: 400, spinning: 3500, energy: 1000, cumulative: 6000 },
  { date: "Nov 18", regDown: 2000, regUp: 500, spinning: 200, energy: 100, cumulative: 900 },
  { date: "Nov 21", regDown: 400, regUp: 600, spinning: 4500, energy: 6000, cumulative: 500 },
  { date: "Nov 24", regDown: 3000, regUp: 2000, spinning: 5500, energy: 1400, cumulative: 300 },
];

// Custom Legend
const renderLegend = (props: any) => {
  const { payload } = props;
  return (
    <div className="flex items-center flex-wrap mb-4">
    <span className="mr-2 font-bold text-xs sm:text-sm">Product:</span>
    {payload.map((entry: any, index: number) => (
      <div key={`item-${index}`} className="flex items-center mr-4">
        <span
          className="inline-block w-2.5 h-2.5 rounded-full mr-2"
          style={{ backgroundColor: entry.color }}
        ></span>
        <span className="text-xs sm:text-sm text-gray-600">{entry.value}</span>
      </div>
    ))}
  </div>
  );
};

const ChartComponent: React.FC = () => {
  return (
    <div className="w-full h-[300px] md:h-[500px] ">
      <ResponsiveContainer width="100%" height={380} >
        <ComposedChart data={data} margin={{ top: 50, right: 20, bottom: 50, left: 20 }}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 14 }}
            padding={{ left: 20, right: 20 }}
            label={{
              value: "Date",
              position: "bottom",
              offset: 10,
              fontSize: 16,
              fontWeight: "bold",
            }}
          />
          <YAxis
            yAxisId="left"
            tickFormatter={(value) => `${value / 1000}k`}
            tick={{ fontSize: 14 }}
            axisLine={false}
            tickLine={false}
            label={{
              value: "Dollars",
              angle: -90,
              position: "insideLeft",
              fontSize: 14,
              fontWeight: "bold",
            }}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            tickFormatter={(value) => `${value / 1000}k`}
            tick={{ fontSize: 14 }}
            axisLine={false}
            tickLine={false}
            label={{
              value: "Cumulative Revenue",
              angle: -90,
              position: "insideRight",
              fontSize: 14,
              fontWeight: "bold",
            }}
          />
          <Legend
            content={renderLegend}
            layout="horizontal"  
            verticalAlign="top"  
            align="center"  
            iconType="circle"  
          />
          <Bar
            yAxisId="left"
            dataKey="regDown"
            stackId="a"
            fill="#F6866A"
            name="A/S Regulation Down"
            barSize={70}
          />
          <Bar
            yAxisId="left"
            dataKey="regUp"
            stackId="a"
            fill="#59E6F6"
            name="A/S Regulation Up"
            barSize={70}
          />
          <Bar
            yAxisId="left"
            dataKey="spinning"
            stackId="a"
            fill="#8A6CE3"
            name="A/S Spinning"
            barSize={70}
          />
          <Bar
            yAxisId="left"
            dataKey="energy"
            stackId="a"
            fill="#FABE7A"
            name="Energy"
            barSize={70}
          />
          <Line
            yAxisId="right"
            type="linear"
            dataKey="cumulative"
            stroke="#7661E2"
            strokeWidth={4}
            dot={false}
            name="Cumulative Revenue"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartComponent;

